// extracted by mini-css-extract-plugin
module.exports = {"main_container":"loggedIn_main_container__8YfC3","sidebar_container":"loggedIn_sidebar_container__2ONV7","sidebar_details_container":"loggedIn_sidebar_details_container__2b1v7"};